'use client'

import { useQueryParams, useRouter } from '@mntn-dev/app-navigation'
import { route } from '@mntn-dev/app-routing'
import type { SignUpModel } from '@mntn-dev/domain-types'
import { useTranslation } from '@mntn-dev/i18n'
import { Button } from '@mntn-dev/ui-components/buttons'
import { Heading } from '@mntn-dev/ui-components/heading'
import { Icon } from '@mntn-dev/ui-components/icon'
import { Stack } from '@mntn-dev/ui-components/stack'
import { Text } from '@mntn-dev/ui-components/text'

type SignUpCompleteProps = {
  registration: SignUpModel
}

export const SignUpComplete = ({
  registration: {
    user: { firstName },
  },
}: SignUpCompleteProps) => {
  const { t } = useTranslation(['sign-up'])
  const router = useRouter()
  const { returnTo } = useQueryParams<'/sign-up'>()

  const handleRedirectClick = () => {
    router.pushUrl(returnTo || route('/dashboard').toRelativeUrl())
  }

  return (
    <Stack gap="4" direction="col" className="my-48 text-center">
      <Stack gap="2" direction="col">
        <Icon
          size="3xl"
          name="checkbox-circle"
          className="m-auto drop-shadow-glow-blue-light"
          color="positive"
        />
        <Heading fontSize="2xl" textColor="positive">
          {t('sign-up:complete.label')}
        </Heading>
      </Stack>
      <Heading fontSize="4xl" className="my-2">
        {t('sign-up:complete.title', { firstName })}
      </Heading>
      <Stack className="-mt-6 items-center" gap="6" direction="col">
        <Text fontSize="lg" textColor="secondary">
          {t('sign-up:complete.subtitle')}
        </Text>
        <Button
          dataTestId="sign-up-complete-button"
          dataTrackingId="sign-up-complete-button"
          type="button"
          onClick={handleRedirectClick}
          width="fit"
          className="px-8"
          iconRight="arrow-right"
        >
          {t('sign-up:complete.action.cta')}
        </Button>
      </Stack>
    </Stack>
  )
}
